import { render, staticRenderFns } from "./FreePlay.vue?vue&type=template&id=78c6e32e&scoped=true"
import script from "./FreePlay.vue?vue&type=script&lang=ts"
export * from "./FreePlay.vue?vue&type=script&lang=ts"
import style0 from "./FreePlay.vue?vue&type=style&index=0&id=78c6e32e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78c6e32e",
  null
  
)

export default component.exports